import { useIsReviewPanelVisible } from "@components/QaReview/hooks/useIsReviewPanelVisible";
import { useReviewAnchors } from "@components/QaReview/hooks/useReviewAnchors";

/** Suggestion count for a goal/target (optionally one of its fields); 0 while the review panel is closed. */
export const useSuggestionCount = (itemId: string, itemType: "stg" | "target"): ((fieldTitle?: string) => number) => {
  const { countForGoalOrTarget } = useReviewAnchors();
  const isReviewPanelVisible = useIsReviewPanelVisible();

  return (fieldTitle) => (isReviewPanelVisible ? countForGoalOrTarget(itemId, itemType, fieldTitle) : 0);
};
